// Default role data structure
const DEFAULT_ROLE_DATA = [
    {
        "eventKey": "dashboard",
        "label": "Dashboard",
        "crud": false,
        "read": false,
        "write": false,
        "subeventKey": [
            {
                "eventKey": "master_dashboard",
                "label": "Master Dashboard Legacy",
                "crud": false,
                "read": false,
                "write": false
            },
            {
                "eventKey": "master_dashboard_v2",
                "label": "Master Dashboard V2",
                "crud": false,
                "read": false,
                "write": false
            },
            {
                "eventKey": "billing_counter_dashboard",
                "label": "Billing Counter Dashboard",
                "crud": false,
                "read": false,
                "write": false
            }
        ]
    },
    {
        "eventKey": "sales_and_orders",
        "label": "Sales & Orders",
        "crud": false,
        "read": false,
        "write": false,
        "subeventKey": [
            {
                "eventKey": "purchase_orders",
                "label": "Purchase Orders",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    // "view": false,
                    "create": false,
                    "edit": false,
                    "delete": false,
                    // "approve": false,
                    // "receive": false,
                    "generate_invoice": false,
                    "export": false,
                    "change_status": false
                }
            },
            {
                "eventKey": "invoices",
                "label": "Invoices",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    // "view": false,
                    // "create": false,
                    // "edit": false,
                    // "delete": false,
                    // "record_payment": false,
                    // "view_transactions": false,
                    "export": false,
                    "print_invoice": false
                }
            },
            {
                "eventKey": "orders",
                "label": "Orders",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    // "view": false,
                    "create": false,
                    // "edit": false,
                    // "delete": false,
                    "cancel": false,
                    "bill": false,
                    "invoice": false,
                    "KOT_info": false,
                    "view_KOT": false,
                    "view_BOT": false,
                    "assign_waiter": false,
                    "void_item": false,
                    "apply_discount": false,
                    // "apply_additional_discount": false,
                    "settle_payment": false,
                    "split_bill": false,
                    // "merge_orders": false,
                    "bill_post": false,
                    "withdraw_bill_post": false,
                    // "regenerate_bill": false,
                    // "generate_invoice": false,
                    // "send_to_kitchen": false,
                    // "update_kitchen_status": false,
                    "hold_order": false,
                    "close_order": false,
                    "update_order": false,
                    "export": false,
                    "close_register": false,
                    "complimentary_item": false,
                    "service_charge": false
                }
            },
            {
                "eventKey": "digital_menu_orders",
                "label": "Digital Menu Orders",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    // "view": false,
                    "edit": false,
                    "accept": false,
                    "reject": false,
                    // "change_status": false
                }
            },
            {
                "eventKey": "quotations",
                "label": "Quotations",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    // "view": false,
                    "create": false,
                    "edit": false,
                    "delete": false,
                    // "convert_to_order": false,
                    "export": false,
                    "generate_invoice": false,
                    "change_status": false
                }
            },
            {
                "eventKey": "transactions",
                "label": "Transactions",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    // "view": false,
                    "create": false,
                    "edit_payment_mode": false,
                    // "delete": false,
                    "export": false
                }
            },
            {
                "eventKey": "requisitions",
                "label": "Requisitions",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "create": false,
                    "delete": false,
                    "export": false,
                    "change_status": false,
                    "create_quotation": false
                }
            },
            {
                "eventKey": "grn",
                "label": "GRN",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    // "view": false,
                    "create": false,
                    // "edit_payment_mode": false,
                    // "delete": false,
                    // "export": false
                }
            }
        ]
    },
    {
        "eventKey": "business_account",
        "label": "Business Account",
        "crud": false,
        "read": false,
        "write": false,
        "subeventKey": [
            {
                "eventKey": "accounts",
                "label": "Accounts",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    // "view": false,
                    "create": false,
                    "edit": false,
                    "delete": false,
                    // "export": false
                }
            },
            {
                "eventKey": "monthly_targets",
                "label": "Monthly Targets",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    // "view": false,
                    "create": false,
                    "edit": false,
                    "delete": false
                }
            },
            {
                "eventKey": "business_registers",
                "label": "Business Registers",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "view": false,
                    // "create": false,
                    // "edit": false,
                    "delete": false,
                    "export": false,
                    // "open_register": false,
                    "close_register": false,
                    // "view_transactions": false
                }
            },
            {
                "eventKey": "open_business_day",
                "label": "Open Business Day",
                "crud": false,
                "read": false,
                "write": false,
                // "actions":{
                //     "open_modal": false
                // }
            }
        ]
    },
    {
        "eventKey": "user_and_customer",
        "label": "User & Customer",
        "crud": false,
        "read": false,
        "write": false,
        "subeventKey": [
            {
                "eventKey": "users",
                "label": "Users",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    // "view": false,
                    "create": false,
                    "edit": false,
                    // "delete": false,
                    "change_status": false,
                    // "reset_password": false,
                    "assign_role": false,
                    // "export": false
                }
            },
            {
                "eventKey": "customers",
                "label": "Customers",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    // "view": false,
                    // "create": false,
                    "edit": false,
                    "delete": false,
                    // "view_orders": false,
                    // "view_transactions": false,
                    // "export": false
                }
            },
            {
                "eventKey": "roles",
                "label": "Roles",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    // "view": false,
                    "create": false,
                    // "edit": false,
                    "delete": false,
                    "change_status": false,
                    "manage_permissions": false
                }
            }
        ]
    },
    {
        "eventKey": "user_profile",
        "label": "User Profile",
        "crud": false,
        "read": false,
        "write": false,
        "subeventKey": [
            {
                "eventKey": "user_profile_image",
                "label": "Profile Image",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    // "view": false,
                    "edit": false
                }
            },
            {
                "eventKey": "personal",
                "label": "Personal",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    // "view": false,
                    "edit": false
                }
            },
            {
                "eventKey": "professional",
                "label": "Professional",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    // "view": false,
                    "edit": false
                }
            }
        ]
    },
    {
        "eventKey": "supplier",
        "label": "Supplier",
        "crud": false,
        "read": false,
        "write": false,
        "subeventKey": [
            {
                "eventKey": "suppliers",
                "label": "Suppliers",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    // "view": false,
                    "create": false,
                    "edit": false,
                    "delete": false,
                    // "view_purchase_orders": false,
                    "export": false
                }
            }
        ]
    },
    {
        "eventKey": "tax_and_discount_codes",
        "label": "Tax & Discount Codes",
        "crud": false,
        "read": false,
        "write": false,
        "subeventKey": [
            {
                "eventKey": "tax_codes",
                "label": "Tax Codes",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    // "view": false,
                    "create": false,
                    "edit": false,
                    "delete": false,
                    "export": false
                }
            },
            {
                "eventKey": "discount_codes",
                "label": "Discount Codes",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    // "view": false,
                    "create": false,
                    "edit": false,
                    "delete": false,
                    "export": false
                }
            }
        ]
    },
    {
        "eventKey": "stock",
        "label": "Stock",
        "crud": false,
        "read": false,
        "write": false,
        "subeventKey": [
            {
                "eventKey": "products",
                "label": "Products",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    // "view": false,
                    "create": false,
                    "edit": false,
                    "delete": false,
                    "add_stock": false,
                    "product_audit_history": false,
                    // "import": false,
                    // "export": false,
                    "manage_variants": false,
                    "manage_addons": false,
                    "manage_ingredients": false,
                    "upload_images": false,
                    "delete_images": false,
                    "generate_barcode": false
                }
            },
            {
                "eventKey": "categories",
                "label": "Categories",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    // "view": false,
                    "create": false,
                    "edit": false,
                    "delete": false,
                    // "import": false,
                    "export": false
                }
            },
            {
                "eventKey": "product_label",
                "label": "Product Label",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "delete": false,
                    "generate": false,
                    // "print": false
                }
            },
            {
                "eventKey": "stock_transfer",
                "label": "Stock Transfer",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    // "view": false,
                    "create": false,
                    "edit": false,
                    "delete": false,
                    "verify": false,
                    "verify_accept": false,
                    "reject": false,
                    // "export": false
                }
            },
            {
                "eventKey": "stock_return",
                "label": "Stock Return",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    // "view": false,
                    "create": false,
                    "edit": false,
                    "delete": false,
                    // "approve": false,
                    "print": false
                }
            },
            {
                "eventKey": "add_on_groups",
                "label": "Add-on Groups",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    // "view": false,
                    "create": false,
                    "edit": false,
                    "delete": false,
                    // "assign_products": false
                }
            }
        ]
    },
    {
        "eventKey": "bookings_and_calendar",
        "label": "Bookings & Calendar",
        "crud": false,
        "read": false,
        "write": false,
        "subeventKey": [
            {
                "eventKey": "bookings_events",
                "label": "Bookings & Events",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    // "view": false,
                    "create": false,
                    "edit": false,
                    "delete": false
                }
            },
            {
                "eventKey": "calendar",
                "label": "Calendar",
                "crud": false,
                "read": false,
                "write": false,
                // "actions": {
                //     "view": false,
                //     "manage_events": false
                // }
            }
        ]
    },
    {
        "eventKey": "reports",
        "label": "Reports",
        "crud": false,
        "read": false,
        "write": false,
        "subeventKey": [
            {
                "eventKey": "download_reports",
                "label": "Download Reports",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    // "view": false,
                    "export": false
                }
            },
            {
                "eventKey": "best_seller_report",
                "label": "Best Seller Report",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    // "view": false,
                    "export": false
                }
            },
            {
                "eventKey": "day_wise_sale_report",
                "label": "Day Wise Sale Report",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    // "view": false,
                    "export": false
                }
            },
            {
                "eventKey": "category_report",
                "label": "Category Report",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    // "view": false,
                    "export": false
                }
            },
            {
                "eventKey": "stock_quantity_alert",
                "label": "Stock Quantity Alert",
                "crud": false,
                "read": false,
                "write": false,
                // "actions": {
                //     "view": false,
                //     "export": false
                // }
            },
            {
                "eventKey": "store_stock_chart",
                "label": "Store Stock Chart",
                "crud": false,
                "read": false,
                "write": false,
            },
            {
                "eventKey": "product_audit_history",
                "label": "Product Audit History",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    // "view": false,
                    "export": false
                }
            },
            {
                "eventKey": "change_in_transaction",
                "label": "Transaction Audit History",
                "crud": false,
                "read": false,
                "write": false,
                // "actions": {
                //     "view": false,
                //     "export": false
                // }
            },
            {
                "eventKey": "night_audit_report",
                "label": "Night Audit Report",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    // "view": false,
                    "tab_export": false,
                    "pdf_export": false,
                    "excel_export": false,
                    // "z_report": false,
                    // "payment_summary": false,
                    // "tax_summary": false,
                    // "cancel_void": false,
                    // "business_register": false,
                    // "category_sales": false,
                    // "item_sales": false,
                    // "hourly_sales": false,
                    // "day_duration": false,
                }
            }
        ]
    },
    {
        "eventKey": "restaurant",
        "label": "Restaurant",
        "crud": false,
        "read": false,
        "write": false,
        "subeventKey": [
            {
                "eventKey": "kitchen_display",
                "label": "Kitchen Display",
                "crud": false,
                "read": false,
                "write": false,
                // "actions": {
                //     "view": false,
                //     "update_status": false,
                //     "mark_complete": false
                // }
            },
            {
                "eventKey": "tables",
                "label": "Tables",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    // "view": false,
                    "create": false,
                    "edit": false,
                    "delete": false,
                    // "assign_waiter": false,
                    // "change_status": false
                }
            },
            {
                "eventKey": "waiter_display",
                "label": "Waiter Display",
                "crud": false,
                "read": false,
                "write": false,
                // "actions": {
                //     "view": false,
                //     "manage_orders": false
                // }
            },
            {
                "eventKey": "restaurant_menu",
                "label": "Restaurant Menu",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "browse_restaurant_menu": false,
                }
            }
        ]
    },
    {
        "eventKey": "notification",
        "label": "Notification",
        "crud": false,
        "read": false,
        "write": false,
        "subeventKey": [
            {
                "eventKey": "notifications",
                "label": "Notifications",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    // "view": false,
                    "delete": false
                }
            }
        ]
    },
    {
        "eventKey": "settings",
        "label": "Settings",
        "crud": false,
        "read": false,
        "write": false,
        "subeventKey": [
            {
                "eventKey": "stores",
                "label": "Stores",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    // "view": false,
                    "create": false,
                    "edit": false,
                    "delete": false
                }
            },
            {
                "eventKey": "operating_hours",
                "label": "Operating Hours",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    // "view": false,
                    "edit": false
                }
            },
            {
                "eventKey": "payment_methods",
                "label": "Payment Methods",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    // "view": false,
                    "create": false,
                    "edit": false,
                    "delete": false
                }
            },
            {
                "eventKey": "billing_counters",
                "label": "Billing Counters",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    // "view": false,
                    "create": false,
                    "edit": false,
                    "delete": false
                }
            },
            {
                "eventKey": "measurement_units",
                "label": "Measurement Units",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    // "view": false,
                    "create": false,
                    "edit": false,
                    "delete": false
                }
            },
            {
                "eventKey": "variant_options",
                "label": "Variant Options",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    // "view": false,
                    "create": false,
                    "edit": false,
                    "delete": false
                }
            },
            {
                "eventKey": "kitchen_displays",
                "label": "Kitchen Displays",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    // "view": false,
                    "create": false,
                    "edit": false,
                    "delete": false
                }
            },
            {
                "eventKey": "bill_posting_settings",
                "label": "Bill Posting Settings",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    // "view": false,
                    "update": false
                }
            }
        ]
    },
    // {
    //     "eventKey": "open_business_day",
    //     "label": "Open Business Day",
    //     "crud": false,
    //     "read": false,
    //     "write": false,
    //     "subeventKey": [
    //         {
    //             "eventKey": "business_modal",
    //             "label": "Business Day Modal",
    //             "crud": false,
    //             "read": false,
    //             "write": false,
    //             "actions": {
    //                 "open_modal": false
    //             }
    //         }
    //     ]
    // }
];

// Helper function to get default role data
// Pass currentStore to conditionally include procurement-only items
export const getDefaultRoleData = (currentStore = null) => {
    const data = JSON.parse(JSON.stringify(DEFAULT_ROLE_DATA)); // Deep clone to avoid mutations
    const isProcurementHub = currentStore?.is_procurement_hub === true || currentStore?.is_procurement_hub === 1;
    if (!isProcurementHub) {
        const salesSection = data.find(section => section.eventKey === 'sales_and_orders');
        if (salesSection && salesSection.subeventKey) {
            salesSection.subeventKey = salesSection.subeventKey.filter(
                sub => sub.eventKey !== 'requisitions' && sub.eventKey !== 'grn'
            );
        }
    }
    return data;
};

// Export the default role data
export default DEFAULT_ROLE_DATA;
